import React, { createContext, useContext, useEffect } from 'react';

/**
 * ThemeContext — currently force-light only.
 *
 * Dark mode was experimented with but rolled back. This provider exists
 * to keep <ThemeProvider> wrapping in App.js valid and to sanitize any
 * stale 'pricemap-theme=dark' values left in users' localStorage during
 * the experiment. The 'dark' class is removed from <html> on every mount
 * so users who toggled it earlier won't see a half-styled dark UI.
 */
const ThemeContext = createContext({ isDarkMode: false, toggleTheme: () => {} });

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    // Force light mode and clear any leftover dark preference.
    document.documentElement.classList.remove('dark');
    try { localStorage.removeItem('pricemap-theme'); } catch {}
  }, []);

  // toggleTheme is a no-op; kept on the value for any lingering callers.
  return (
    <ThemeContext.Provider value={{ isDarkMode: false, toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
};
